import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base';
import { LocationsRepository } from '../../repositories';

@Injectable({providedIn: 'root'})
export class GetWayPointsForJobUsecase
  implements UseCase<string, number[][]>
{
  constructor(private locationRepository: LocationsRepository) {}

  execute(params: string): Observable<number[][]> {
    return this.locationRepository.getWayPointsForJob(params);
  }
}
